import { render } from "./MergeConfirmationModal.vue?vue&type=template&id=6c3feb48"
import script from "./MergeConfirmationModal.vue?vue&type=script&lang=js"
export * from "./MergeConfirmationModal.vue?vue&type=script&lang=js"

import "./MergeConfirmationModal.vue?vue&type=style&index=0&id=6c3feb48&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__